import { Table } from "govuk-react";
import React, { memo } from "react";

interface SummaryStepFieldsProps {
    caption: string;
    fields: {
        [label: string]: string | boolean | File[] | undefined;
    };
}

export const SummaryStepFields = memo((props: SummaryStepFieldsProps) => {
    const { fields, caption } = props;

    return (
        <Table caption={caption}>
            {Object.entries(fields).map(([key, value]) => {
                if (value === undefined) {
                    return null;
                }
                return (
                    <Table.Row key={key}>
                        <Table.CellHeader setWidth="one-quarter">{key}</Table.CellHeader>
                        <Table.Cell setWidth="three-quarters">
                            <PrePpWlSummaryFieldValue value={value} />
                        </Table.Cell>
                    </Table.Row>
                );
            })}
        </Table>
    );
});

const PrePpWlSummaryFieldValue = memo(({ value }: { value?: string | boolean | File[] }): React.ReactElement => {
    if (Array.isArray(value)) {
        return <>{value.map((file) => ` ${file.name}`).toString()}</>;
    }
    if (typeof value === "boolean") {
        return <> {value ? "Yes" : "No"}</>;
    }
    return <>{value}</>;
});
